import {schema} from 'normalizr'

const barcode2set = new schema.Entity(
	'barcode2set',{},{idAttribute: value => value.barcode.index})
const barcodes_schema = [barcode2set]
export default barcodes_schema